import ease from '@/constants/ease';
import cx from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { AutoplayInterval } from './TabbedAnimatedCarousel.constants';
import { Feature } from './TabbedAnimatedCarousel.js';

export type CarouselDesktopNavProps = {
  features: Feature[];
  activeFeatureIndex: number;
  onClick: (index: number) => void;
}

export const CarouselDesktopNav = ({ features, activeFeatureIndex, onClick }: CarouselDesktopNavProps) =>
  <div className="flex gap-1 items-center justify-center">
    {features.map(({ title, icon }, index) => (
      <div key={`feature-desktop-nav-${title?.replace(/\s+/g, '-') || index}`} className="w-25 relative flex flex-col gap-1 items-center">
        <button
          className={cx('block button button-size-medium button-drawer-green', {
            active: index === activeFeatureIndex,
          })}
          onClick={() => onClick(index)}
        >
          <div className="flex items-center gap-1">
            {icon}
            <div>{title}</div>
          </div>
        </button>

        <div className="h-[6px] w-full rounded-10 overflow-hidden bg-gray-100 relative">
          <AnimatePresence mode="wait">
            {index === activeFeatureIndex && (
              <motion.div
                initial={{ width: 0 }}
                animate={{
                  width: '100%',
                  transition: {
                    duration: AutoplayInterval / 1000,
                    ease: 'linear',
                  },
                }}
                exit={{
                  opacity: 0,
                  transition: {
                    duration: 400 / 1000,
                    ease: ease.appear,
                  },
                }}
                className="absolute inset-0 h-[6px] rounded-10 overflow-hidden bg-green-800"
              />
            )}
          </AnimatePresence>
        </div>
      </div>
    ))}
  </div>
